// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1595) return "static/chunks/1595.9f6a1baa8d8f33d5.js";
	if (chunkId === 3987) return "static/chunks/a3319169.05fae8d158e45e56.js";
	if (chunkId === 1056) return "static/chunks/1056.b94eaff86b953fe7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1426":"cc12850461a5bb4a","1900":"59901632d723ff0f","2260":"e72e16f15c270784","3904":"6c31651c65979fce","9350":"43afd4c90cb056a7"}[chunkId] + ".js";
};